import React, { useContext } from 'react';

import { TabStore } from '@ariakit/react';

import { InteractiveCodeContext } from '../../../../context/InteractiveCodeContext';
import { useResponsiveWidth } from '../../../../hooks/useResponsiveWidth';
import { CodeBlockHeader } from '../../CodeBlockHeader';
import { CodeBlockHeaderMenu } from '../../CodeBlockHeaderMenu';
import { CodeBlockHeaderTabs } from '../../CodeBlockHeaderTabs';

import * as classes from './style.module.scss';

interface Props {
  tab: TabStore;
}

export const InteractiveHeader: React.FC<Props> = ({ tab }) => {
  const { files, codeBlockIndex, setCodeBlockIndex } = useContext(
    InteractiveCodeContext,
  );

  const [ref, measuredRef, widerThanParent] = useResponsiveWidth(30);

  if (!files.length || !files[0]) {
    return null;
  }

  return (
    <CodeBlockHeader>
      <div className={classes.root} ref={ref}>
        <div
          ref={measuredRef}
          className={classes.container}
          style={{ display: widerThanParent ? 'none' : 'flex' }}
        >
          <CodeBlockHeaderTabs
            tab={tab}
            items={files}
            aria-label="Select a file"
          />
        </div>
        <div
          className={classes.container}
          style={{ display: widerThanParent ? 'flex' : 'none' }}
        >
          <CodeBlockHeaderMenu
            active={codeBlockIndex}
            items={files}
            onClick={setCodeBlockIndex}
            aria-label="Select a file"
          />
        </div>
      </div>
    </CodeBlockHeader>
  );
};
